import { useContext } from 'react';

import { WorkoutContextType } from '../types';

import WorkoutContext from '../context';

const useWorkoutContext = () => useContext<WorkoutContextType>(WorkoutContext);

export default useWorkoutContext;
